export default __webpack_public_path__ + "static/media/Merriweather-Bold.7b45103b.ttf";